"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContrastText = void 0;
const tslib_1 = require("tslib");
const colors_1 = require("@mui/material/colors");
const styles_1 = require("@mui/material/styles");
const createPalette_1 = tslib_1.__importDefault(require("@mui/material/styles/createPalette"));
const colors_2 = require("./../colors");
const getContrastText = (color, contrastThreshold) => (0, styles_1.getContrastRatio)(color, "#FFFFFF") >= contrastThreshold ? "#FFFFFF" : "rgba(0, 0, 0, 0.87)";
exports.getContrastText = getContrastText;
/**
 * Some (legacy) places in argus the criticallity is defined as a number between 0 and 9.
 * These numbers are later mapped to different criticallity levels. The index of the array
 * indicate the mapping between a numeric severity and the corresponding criticallity enum.
 */
const criticalityIndex = [
    "low",
    "low",
    "low",
    "low",
    "medium",
    "high",
    "critical",
    "critical",
    "critical",
    "critical",
    "critical",
];
function createPalette(options = {}) {
    const { 
    /* Materials default is 3 */
    contrastThreshold = 3, } = options;
    const tertiary = [
        // tertiary1
        {
            contrastText: (0, exports.getContrastText)(colors_2.tertiary1[500], contrastThreshold),
            dark: colors_2.tertiary1[500],
            light: colors_2.tertiary1[200],
            main: colors_2.tertiary1[300],
        },
        // tertiary2
        {
            contrastText: (0, exports.getContrastText)(colors_2.tertiary2[700], contrastThreshold),
            dark: colors_2.tertiary2[900],
            light: colors_2.tertiary2[400],
            main: colors_2.tertiary2[700],
        },
        // tertiary3
        {
            contrastText: (0, exports.getContrastText)(colors_2.tertiary3[700], contrastThreshold),
            dark: colors_2.tertiary3[900],
            light: colors_2.tertiary3[300],
            main: colors_2.tertiary3[700],
        },
        // tertiary4
        {
            contrastText: (0, exports.getContrastText)(colors_2.tertiary4[100], contrastThreshold),
            dark: colors_2.tertiary4[200],
            light: colors_2.tertiary4[50],
            main: colors_2.tertiary4[100],
        },
        // tertiary5
        {
            contrastText: (0, exports.getContrastText)(colors_2.tertiary5[500], contrastThreshold),
            dark: colors_2.tertiary5[800],
            light: colors_2.tertiary5[300],
            main: colors_2.tertiary5[500],
        },
        // tertiary6
        {
            contrastText: (0, exports.getContrastText)(colors_2.tertiary6[800], contrastThreshold),
            dark: colors_2.tertiary6[900],
            light: colors_2.tertiary6[500],
            main: colors_2.tertiary6[800],
        },
        // tertiary7
        {
            contrastText: (0, exports.getContrastText)(colors_2.tertiary7[200], contrastThreshold),
            dark: colors_2.tertiary7[300],
            light: colors_2.tertiary7[100],
            main: colors_2.tertiary7[200],
        },
        // tertiary8
        {
            contrastText: (0, exports.getContrastText)(colors_2.tertiary8[400], contrastThreshold),
            dark: colors_2.tertiary8[600],
            light: colors_2.tertiary8[200],
            main: colors_2.tertiary8[400],
        },
    ];
    const criticality = {
        critical: {
            contrastText: (0, exports.getContrastText)(colors_2.red[500], contrastThreshold),
            dark: colors_2.red[700],
            light: colors_2.red[200],
            main: colors_2.red[500],
        },
        high: {
            contrastText: (0, exports.getContrastText)(colors_2.amber[400], contrastThreshold),
            dark: colors_2.amber[700],
            light: colors_2.amber[200],
            main: colors_2.amber[400],
        },
        low: {
            contrastText: (0, exports.getContrastText)(colors_2.blue[700], contrastThreshold),
            dark: colors_2.blue[900],
            light: colors_2.blue[200],
            main: colors_2.blue[700],
        },
        medium: {
            contrastText: (0, exports.getContrastText)(colors_2.green[500], contrastThreshold),
            dark: colors_2.green[800],
            light: colors_2.green[200],
            main: colors_2.green[500],
        },
    };
    /**
     * All main, light and dark colors are the same.
     * The downside of this is is that these colors *cannot* be used on
     * interactive elements. Eg Buttons. Effects like hover and ripple need
     * dark and light colors.
     */
    const sampleVerdictColor = {
        malicious: {
            contrastText: (0, exports.getContrastText)(colors_2.red[700], contrastThreshold),
            dark: colors_2.red[700],
            light: colors_2.red[700],
            main: colors_2.red[700],
        },
        unwanted: {
            contrastText: (0, exports.getContrastText)(colors_2.orange[800], contrastThreshold),
            dark: colors_2.orange[800],
            light: colors_2.orange[800],
            main: colors_2.orange[800],
        },
        suspicious: {
            contrastText: (0, exports.getContrastText)(colors_2.orange[500], contrastThreshold),
            dark: colors_2.orange[500],
            light: colors_2.orange[500],
            main: colors_2.orange[500],
        },
        unknown: {
            contrastText: (0, exports.getContrastText)(colors_1.grey[700], contrastThreshold),
            dark: colors_1.grey[700],
            light: colors_1.grey[700],
            main: colors_1.grey[700],
        },
        benign: {
            contrastText: (0, exports.getContrastText)(colors_2.green[800], contrastThreshold),
            dark: colors_2.green[800],
            light: colors_2.green[800],
            main: colors_2.green[800],
        },
        noFindings: {
            contrastText: (0, exports.getContrastText)(colors_2.green[800], contrastThreshold),
            dark: colors_2.green[800],
            light: colors_2.green[800],
            main: colors_2.green[800],
        },
    };
    const getTertiaryColor = (index) => {
        if (index >= tertiary.length) {
            // tslint:disable-next-line:no-console
            console.error(`@mnemonic/mui5: You asked for a tertiaryColor index which does not exists. You as for index ${index} we only have ${tertiary.length} tertiary colors`);
        }
        return tertiary[index];
    };
    const getVerdictColor = (key) => {
        if (!Object.keys(sampleVerdictColor).some((x) => x === key)) {
            console.error(`@mnemonic/mui5: You asked for a verdict color which does not exists. You asked for index ${key}.`);
            // Fallback to unknown
            return sampleVerdictColor["unknown"];
        }
        return sampleVerdictColor[key];
    };
    const getCriticalityColor = (crit) => {
        if (typeof crit === "number") {
            if (crit >= criticalityIndex.length) {
                // tslint:disable-next-line:no-console
                console.error(`@mne-core/mui5: You asked for a criticality index which does not exists. You as for index ${crit} we only have ${criticalityIndex.length} criticality indexes`);
            }
            return criticality[criticalityIndex[crit]];
        }
        return criticality[crit.toLowerCase()];
    };
    const error = {
        light: colors_2.red[200],
        main: colors_2.red[500],
        dark: colors_2.red[700],
    };
    return (0, createPalette_1.default)({
        criticality,
        getCriticalityColor,
        getTertiaryColor,
        getVerdictColor,
        tertiary,
        error,
        background: {
            default: colors_2.black[100],
        },
        grey: colors_2.black,
        ...options,
    });
}
exports.default = createPalette;
